<script>
  import { firstLevelMenus } from "../../editor/menuSchema.js";
  import { validateFilter as vf } from "../../editor/component/dataTransform.js";
  import ItemResponse from "../component/ItemResponse.svelte";
  import { toFilterString } from "../../fronto/utility.js";
  import {
    callQueue,
    data,
    dataInfo,
    activeSpec,
    unlockedSpecs,
    currentSpec,
    currentElementLockGroup,
  } from "../../editor/storage.js";
  import { onMount } from "svelte";

  // event functions
  export let inputFocusAction;
  export let inputBlurAction;

  let subMenu;
  function setSubMenu(name) {
    subMenu = name;
  }
  function cancelSubMenu() {
    subMenu = undefined;
  }

  let transform_lock;

  function updateFilter(ti, event) {
    let filterString = event.target.value;
    // .querySelector(`#form-filter-${ti}`).value;
    if (vf(filterString)) {
      let rule = {
        category: "manual",
        description:
          ti === "new" ? "Add a new data filter" : "Modify a data filter",
        specifier: { role: "transform" },
        action: ti === "new" ? "add" : "modify",
        option: {
          operation: "filter",
          expression: filterString.startsWith("(")
            ? filterString
            : toFilterString(JSON.parse(filterString)),
        },
      };
      if (event.target.layer) {
        rule.specifier.layer = { id: event.target.layer };
        let trfm_index = ti.split("-")[1];
        if (ti !== "new") {
          rule.specifier.index = parseInt(trfm_index);
        }
      } else if (ti !== "new") {
        rule.specifier.index = ti;
      }
      callQueue.update((queue) => {
        queue.add([rule], $unlockedSpecs).apply();
        return queue;
      });
      // if (ti === "new") {
      //   document.querySelector(`#form-filter-${ti}`).value = "";
      //   document.querySelector(`#form-filter-${ti}`).innerHTML = "";
      // }
    } else {
      console.log("Wrong filter expression!");
    }
  }

  function deleteFilter(ti, layer) {
    let filterString = document.querySelector(`#form-filter-${ti}`).value;
    if (filterString) {
      let rule = {
        category: "manual",
        description: "Remove a data filter",
        specifier: {
          role: "data.transform",
          operation: "filter",
          index: ti,
          filter: filterString,
        },
        action: "remove",
      };
      if (layer) {
        rule.specifier.layer = { id: layer.name };
        let trfm_index = ti.split("-")[1];
        if (ti !== "new") {
          rule.specifier.index = parseInt(trfm_index);
        }
      }
      callQueue.update((queue) => {
        queue.add([rule], $unlockedSpecs).apply();
        return queue;
      });
    }
  }

  function updateCalculate(ti, event) {
    let calcString = event.target.value;
    // .querySelector(`#form-filter-${ti}`).value;
    if (vf(calcString)) {
      let rule = {
        category: "manual",
        description:
          ti === "new"
            ? "Add a new calculated field"
            : "Modify a calculated field",
        specifier: { role: "transform" },
        action: ti === "new" ? "add" : "modify",
        option: {
          operation: "calculate",
          expression: calcString.startsWith("(")
            ? calcString
            : toFilterString(JSON.parse(calcString)),
          output: event.target.as,
        },
      };
      if (event.target.layer) {
        rule.specifier.layer = { id: event.target.layer };
        let trfm_index = ti.split("-")[1];
        if (ti !== "new") {
          rule.specifier.index = parseInt(trfm_index);
        }
      } else if (ti !== "new") {
        rule.specifier.index = ti;
      }
      callQueue.update((queue) => {
        queue.add([rule], $unlockedSpecs).apply();
        return queue;
      });
      // if (ti === "new") {
      //   document.querySelector(`#form-calculate-${ti}`).value = "";
      //   document.querySelector(`#form-calculate-${ti}`).innerHTML = "";
      // }
    } else {
      console.log("Wrong calculate expression!");
    }
  }

  function deleteCalculate(ti, layer) {
    let filterString = document.querySelector(`#form-filter-${ti}`).value;
    if (filterString) {
      let rule = {
        category: "manual",
        description: "Remove a data filter",
        specifier: {
          role: "data.transform",
          operation: "filter",
          index: ti,
          filter: filterString,
        },
        action: "remove",
      };
      if (layer) {
        rule.specifier.layer = { id: layer.name };
        let trfm_index = ti.split("-")[1];
        if (ti !== "new") {
          rule.specifier.index = parseInt(trfm_index);
        }
      }
      callQueue.update((queue) => {
        queue.add([rule], $unlockedSpecs).apply();
        return queue;
      });
    }
  }

  function updateLock(event) {
    if ($currentElementLockGroup.length > 0) {
      let newValue = event.target.checked;
      if (newValue !== undefined) {
        let rule = {
          category: "lock",
          description: (newValue ? "Lock" : "Unlock") + " data transformatoins",
          specifier: {
            role: "data.transform",
          },
          action: "lock",
          option: {
            transform: newValue,
          },
        };
        callQueue.update((queue) => {
          queue.add([rule], $currentElementLockGroup).apply();
          return queue;
        });
      }
    }
  }

  function setValues() {
    if ($currentSpec?.fronto?.globalLock?.transform !== undefined) {
      transform_lock = $currentSpec?.fronto?.globalLock?.transform;
    }
  }
  currentSpec.subscribe(() => {
    setValues();
  });
  onMount(() => {
    setValues();
  });
</script>

<section class="second-level-menu">
  <h2>
    {firstLevelMenus["transform"]?.title || "Data transform"}
  </h2>

  {#if $data && $dataInfo?.header && $dataInfo?.columns}
    {#if $activeSpec == -1}
      <div
        class="dupo-menu-pane mb-2 warn-msg pt-2"
        style="margin-top: -0.5rem;"
      >
        <div class="dupo-menu-pane-row">
          <p class="text-sm">Create or select an artboard!</p>
        </div>
      </div>
    {:else if !$unlockedSpecs.includes($currentSpec.uid)}
      <div
        class="dupo-menu-pane mb-2 warn-msg pt-2"
        style="margin-top: -0.5rem;"
      >
        <div class="dupo-menu-pane-row">
          <p class="text-sm">Unlock this artboard first!</p>
        </div>
      </div>
    {:else if !subMenu}
      <div class="dupo-menu-pane mb-2">
        <div class="dupo-menu-pane-row">
          <p class="text-sm">Edit data transformations.</p>
        </div>
        <div class="dupo-menu-pane-form-row">
          <button
            class="menu-second-level"
            type="button"
            on:click={() => {
              setSubMenu("filter");
            }}>Filter</button
          >
        </div>
        <div class="dupo-menu-pane-form-row">
          <button
            class="menu-second-level"
            type="button"
            on:click={() => {
              setSubMenu("calculate");
            }}>Calculate a new field</button
          >
        </div>
      </div>

      <!-- lock -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="lock"
          tooltipMessage="Prevent suggesting responsive alternatives that make changes to data transformation. Element-Lock applies to its source or target design(s)."
          title="Lock data transformations"
          token={"data-lock"}
          value={transform_lock}
          {inputFocusAction}
          {inputBlurAction}
          changeAction={(event) => {
            updateLock(event);
          }}
        />
      </div>
    {:else if subMenu === "filter"}
      <!-- make a new filter -->
      <div class="dupo-menu-pane">
        <div class="dupo-menu-pane-row mb-2">
          <h3 class="h-sub">Add a new filter (to filter in).</h3>
        </div>
      </div>

      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="filter-json"
          token="form-filter-new"
          title="Filter statement"
          {inputFocusAction}
          {inputBlurAction}
          changeAction={(event) => {
            updateFilter("new", event);
          }}
          cancel={() => {
            cancelSubMenu();
          }}
        />
      </div>

      <div class="pane-divider" />

      <!-- show existing filters -->
      <!-- refresh -->
      {#if $currentSpec?.fronto?.transform}
        <div class="dupo-menu-pane">
          <div class="dupo-menu-pane-row mb-2">
            <h3 class="h-sub">Current global filter(s)</h3>
          </div>
        </div>
        {#each $currentSpec?.fronto?.transform as trfm, ti}
          {#if trfm.filter !== undefined}
            <div class="dupo-menu-pane mb-2">
              <ItemResponse
                type="filter-json"
                token={`form-filter-${ti}`}
                title={`Filter statement ${ti + 1}`}
                {inputFocusAction}
                {inputBlurAction}
                value={trfm.filter}
                changeAction={(event) => {
                  updateFilter(ti, event);
                }}
                cancel={() => {
                  cancelSubMenu();
                }}
              />
              <div class="dupo-menu-pane-button-row">
                <!-- <button
                  type="button"
                  id={`confirm-filter-${ti}`}
                  on:click={() => {
                    updateFilter(ti);
                  }}
                  disabled>Update</button
                > -->
                <button
                  type="button"
                  id={`cancel-filter-${ti}`}
                  on:click={() => deleteFilter(ti)}
                  ><i class="bi bi-trash me-1" />Delete</button
                >
              </div>
            </div>
          {/if}
        {/each}
      {/if}
      {#if $currentSpec?.fronto?.transform}
        <div class="dupo-menu-pane">
          <div class="dupo-menu-pane-row mb-2">
            <h3 class="h-sub">Current layer-specific filter(s)</h3>
          </div>
        </div>
        {#each $currentSpec?.fronto?.layer as layer, li}
          {#if layer.transform}
            <div class="dupo-menu-pane">
              <div class="dupo-menu-pane-row mb-2">
                <h3 class="h-sub">Layer {li + 1} / {layer.name}</h3>
              </div>
            </div>
            {#each layer.transform as trfm, ti}
              {#if trfm.filter !== undefined}
                <div class="dupo-menu-pane mb-2">
                  <ItemResponse
                    type="filter-json"
                    token={`form-filter-${li}-${ti}`}
                    title={`Filter statement ${li + 1} / ${ti + 1}`}
                    {inputFocusAction}
                    {inputBlurAction}
                    value={trfm.filter}
                    specifiedLayer={layer.name}
                    changeAction={(event) => {
                      updateFilter(`${li}-${ti}`, event);
                    }}
                    cancel={() => {
                      cancelSubMenu();
                    }}
                  />
                  <div class="dupo-menu-pane-button-row">
                    <button
                      type="button"
                      id={`cancel-filter-${li}-${ti}`}
                      on:click={() => deleteFilter(`${li}-${ti}`, layer)}
                      ><i class="bi bi-trash me-1" />Delete</button
                    >
                  </div>
                </div>
              {/if}
            {/each}
          {/if}
        {/each}
      {/if}
      <div class="pane-divider" />
      <div class="dupo-menu-pane mb-2">
        <div class="dupo-menu-pane-button-row">
          <button type="button" on:click={() => cancelSubMenu()}
            ><i class="bi bi-arrow-left me-1" />Go back</button
          >
        </div>
      </div>
    {:else if subMenu === "calculate"}
      <!-- make a new calculate -->
      <div class="dupo-menu-pane">
        <div class="dupo-menu-pane-row mb-2">
          <h3 class="h-sub">Calculate a new field</h3>
        </div>
      </div>

      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="field-calculate"
          token="form-calculate-new"
          title="New Calculate"
          {inputFocusAction}
          {inputBlurAction}
          changeAction={(event) => {
            updateCalculate("new", event);
          }}
          cancel={() => {
            cancelSubMenu();
          }}
        />
      </div>

      <div class="pane-divider" />

      <!-- show existing filters -->
      <!-- refresh -->
      {#if $currentSpec?.fronto?.transform}
        <div class="dupo-menu-pane">
          <div class="dupo-menu-pane-row mb-2">
            <h3 class="h-sub">Current global calculate(s)</h3>
          </div>
        </div>
        {#each $currentSpec?.fronto?.transform as trfm, ti}
          {#if trfm.calculate !== undefined}
            <div class="dupo-menu-pane mb-2">
              <ItemResponse
                type="field-calculate"
                token={`form-calculate-${ti}`}
                title={`Calculate statement ${ti + 1}`}
                {inputFocusAction}
                {inputBlurAction}
                value={{ expression: trfm.calculate, as: trfm.as }}
                changeAction={(event) => {
                  updateCalculate(ti, event);
                }}
                cancel={() => {
                  cancelSubMenu();
                }}
              />
              <div class="dupo-menu-pane-button-row">
                <button
                  type="button"
                  id={`cancel-calculate-${ti}`}
                  on:click={() => deleteCalculate(ti)}
                  ><i class="bi bi-trash me-1" />Delete</button
                >
              </div>
            </div>
          {/if}
        {/each}
      {/if}
      {#if $currentSpec?.fronto?.transform}
        <div class="dupo-menu-pane">
          <div class="dupo-menu-pane-row mb-2">
            <h3 class="h-sub">Current layer-specific calculated field(s)</h3>
          </div>
        </div>
        {#each $currentSpec?.fronto?.layer as layer, li}
          {#if layer.transform}
            <div class="dupo-menu-pane">
              <div class="dupo-menu-pane-row mb-2">
                <h3 class="h-sub">Layer {li + 1} / {layer.name}</h3>
              </div>
            </div>
            {#each layer.transform as trfm, ti}
              {#if trfm.filter !== undefined}
                <div class="dupo-menu-pane mb-2">
                  <ItemResponse
                    type="field-calculate"
                    token={`form-calculate-${li}-${ti}`}
                    title={`Filter statement ${li + 1} / ${ti + 1}`}
                    {inputFocusAction}
                    {inputBlurAction}
                    value={{ expression: trfm.calculate, as: trfm.as }}
                    specifiedLayer={layer.name}
                    changeAction={(event) => {
                      updateCalculate(`${li}-${ti}`, event);
                    }}
                    cancel={() => {
                      cancelSubMenu();
                    }}
                  />
                  <div class="dupo-menu-pane-button-row">
                    <button
                      type="button"
                      id={`cancel-calculate-${li}-${ti}`}
                      on:click={() => deleteCalculate(`${li}-${ti}`, layer)}
                      ><i class="bi bi-trash me-1" />Delete</button
                    >
                  </div>
                </div>
              {/if}
            {/each}
          {/if}
        {/each}
      {/if}
      <div class="pane-divider" />
      <div class="dupo-menu-pane mb-2">
        <div class="dupo-menu-pane-button-row">
          <button type="button" on:click={() => cancelSubMenu()}
            ><i class="bi bi-arrow-left me-1" />Go back</button
          >
        </div>
      </div>
    {/if}
  {:else}
    <div class="dupo-menu-pane mb-2">Please add data.</div>
  {/if}
</section>
